import React from 'react';
import PropTypes from 'prop-types';

import { Text } from './style';

const Name = ({ original = {} }) => {
  const { customer = {} } = original;
  const { name, surname } = customer;

  return (
    <Text>{`${name || ''} ${surname || ''}`}</Text>
  );
};

Name.propTypes = {
  original: PropTypes.shape({
    customer: PropTypes.shape({
      name   : PropTypes.string,
      surname: PropTypes.string,
    }),
  }),
};

Name.defaultProps = {
  original: {},
};

export default Name;
